// project imports
import { GuardProps } from 'types';
import { useSelector } from 'store';
import NotFoundPage from 'views/pages/maintenance/Error';

// ==============================|| PRIORITY GUARD ||============================== //

/**
 * Priority guard for routes for Priority companies
 * @param {PropTypes.node} children children element/node
 */

export default function PriorityGuard({ children }: GuardProps) {
  const companyType = useSelector((state) => state.company?.CompanyType);

  if (companyType !== 'priority') {
    return <NotFoundPage />;
  }

  return children;
}
